import baseApi from './baseApi';
// Define a service using a base URL and injected endpoints
export const siteInfoApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getSiteIdBySubdomain: builder.query({
            query: (subdomain) => `/api/sites/subdomains/${subdomain}`,
            transformResponse: (siteInfo) => {
                return siteInfo.siteId;
            },
        }),
        getSiteInfoBySubdomain: builder.query({
            query: (subdomain) => `/api/sites/subdomains/${subdomain}`,
        }),
        getSiteNavigation: builder.query({
            query: (siteId) => `/api/sites/${siteId}/shell/navigation`,
        }),
        getSiteThemeColors: builder.query({
            query: (siteId) => `/api/theme/sites/${siteId}/branding-theme`,
        }),
        getSiteSettings: builder.query({
            query: ({ siteId }) => `/api/mgmt-console/${siteId}/settings`,
        }),
    }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSiteIdBySubdomainQuery, useGetSiteInfoBySubdomainQuery, useGetSiteNavigationQuery, useGetSiteThemeColorsQuery, useGetSiteSettingsQuery, } = siteInfoApi;
